import PropTypes from "prop-types";
import React from "react";
import { MenuItem, Select, Stack } from "@mui/material";

import { ChevronRight } from "../../Assets/Icons";

export const MenuPaperProps = {
  sx: {
    backgroundColor: "var(--bg-primary)",
    borderRadius: "var(--rounded-xl)",
    border: "var(--card-border)",
  },
};

export const MenuItemProps = {
  sx: {
    minHeight: "auto",
    font: "normal normal 400 14px/20px Poppins, sans-serif",
    color: "var(--mist)",
    "&.Mui-selected": {
      color: "var(--charcoal) !important",
      backgroundColor: "var(--primary-400) !important",

      "& svg path[fill]": {
        fill: "var(--charcoal)",
      },

      "& svg path[stroke]": {
        stroke: "var(--charcoal)",
      },
    },
    "&:not(.Mui-selected):hover": {
      backgroundColor: "rgb(from var(--mist) r g b / 10%)",
    },
    "&:not(.Mui-selected).Mui-focused": {
      backgroundColor: "rgb(from var(--mist) r g b / 20%)",
    },
  },
};

export const MenuListProps = {
  sx: {
    maxHeight: "300px",
    "& .MuiMenuItem-root": { ...MenuItemProps.sx },
  },
};

const SelectField = React.forwardRef(
  ({ className = "", label, description, options, errorMessage, helperText, dropUp = false, ...props }, ref) => {
    return (
      <div className={`select-field ${className}`}>
        {!!label && <label>{label}</label>}
        {!!description && <span className="description">{description}</span>}
        <div className="input-icon-wrapper">
          <Select
            variant="outlined"
            IconComponent={ChevronRight}
            {...props}
            inputRef={ref}
            MenuProps={{
              PaperProps: MenuPaperProps,
              MenuListProps,
              anchorOrigin: dropUp
                ? { vertical: "top", horizontal: "left" }
                : { vertical: "bottom", horizontal: "left" },
              transformOrigin: dropUp
                ? { vertical: "bottom", horizontal: "left" }
                : { vertical: "top", horizontal: "left" },
            }}
          >
            {options?.length === 0 && (
              <Stack
                className="text-base-medium color--american-silver"
                alignItems="center"
                justifyContent="center"
                sx={{ height: "300px" }}
              >
                No options available
              </Stack>
            )}
            {options?.map((option, idx) => (
              <MenuItem key={idx} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        {!!errorMessage && <span className="error-message">{errorMessage}</span>}
        {!!helperText && <span className="helper-text">{helperText}</span>}
      </div>
    );
  }
);

SelectField.prototype = {
  className: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  dropUp: PropTypes.bool,
};

export default SelectField;
